import {prefersDarkMode$} from '../../libs/shared/helpers/src/environment/darkMode';
import {reportToBugsnag} from '../../srcCommon/services/bugsnag/bugsnag';
import {InterfaceEventsEnum, trackInterfaceEvent} from './tracking';

export function setupDarkModeTracking() {
  prefersDarkMode$.subscribe(
    (prefersDarkMode) => {
      trackInterfaceEvent(InterfaceEventsEnum.SYSTEM_DARK_MODE_CHANGE, {
        prefers_dark_mode: prefersDarkMode,
        local_hour_of_day: new Date().getHours(),
      });
    },
    (error) => {
      reportToBugsnag(error);
    },
  );
}
